import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { TYPE_IMAGE, TYPE_USER } from "csi/reflection/reflectionConstants";
import types from "csi/types";
import { isCurrencyFormat, isPercentFormat } from "csi/utility/numberUtility";
import { FunctionComponent } from "react";
import { C8NodeType } from "src/c8-platform/type/node";
import { C8AttributeType, VALUE_TYPE, getPrimitiveValueType } from "src/c8-platform/type/value";
import BarcodeIcon from "../icons/BarcodeIcon";
import BooleanIcon from "../icons/BooleanIcon";
import CalendarIcon from "../icons/CalendarIcon";
import CommentIcon from "../icons/CommentIcon";
import CurrencyIcon from "../icons/CurrencyIcon";
import DropDownIcon from "../icons/DropDownIcon";
import EmailIcon from "../icons/EmailIcon";
import FileIcon from "../icons/FileIcon";
import ImageIcon from "../icons/ImageIcon";
import LinkIcon from "../icons/LinkIcon";
import NumberIcon from "../icons/NumberIcon";
import PercentIcon from "../icons/PercentIcon";
import PhoneIcon from "../icons/PhoneIcon";
import ReferralIcon from "../icons/ReferralIcon";
import RichTextIcon from "../icons/RichTextIcon";
import TextIcon from "../icons/TextIcon";

const {
	FORMAT_BARCODE,
	FORMAT_COMMENT,
	FORMAT_COMMENT_LATEST,
	FORMAT_EMAIL,
	FORMAT_IMAGE,
	FORMAT_LOCALIZED,
	FORMAT_LOCALIZED_TEXTAREA,
	FORMAT_LOCALIZED_RICH,
	FORMAT_PHONE,
	FORMAT_RICH,
	FORMAT_SELECTION,
	FORMAT_TAG,
	FORMAT_TEXTAREA,
	FORMAT_TYPE,
	FORMAT_URL,
} = types;

const {
	BOOLEAN,
	DOUBLE,
	ENUM,
	INTEGER,
	INT64,
	REF,
	STRING,
	TIME,
	URL,
} = VALUE_TYPE;

const REF_TARGET_ICONS: Record<C8NodeType, FunctionComponent> = {
	[TYPE_IMAGE]: ImageIcon,
	[TYPE_USER]: PersonOutlineOutlinedIcon,
};

const STRING_FORMAT_ICONS: Record<string, FunctionComponent> = {
	[FORMAT_BARCODE]: BarcodeIcon,
	[FORMAT_COMMENT]: CommentIcon,
	[FORMAT_COMMENT_LATEST]: CommentIcon,
	[FORMAT_EMAIL]: EmailIcon,
	[FORMAT_LOCALIZED]: TextIcon,
	[FORMAT_LOCALIZED_TEXTAREA]: TextIcon,
	[FORMAT_LOCALIZED_RICH]: RichTextIcon,
	[FORMAT_PHONE]: PhoneIcon,
	[FORMAT_RICH]: RichTextIcon,
	[FORMAT_SELECTION]: DropDownIcon,
	[FORMAT_TAG]: DropDownIcon,
	[FORMAT_TEXTAREA]: TextIcon,
	[FORMAT_TYPE]: TextIcon,
	[FORMAT_URL]: LinkIcon,
};

/** return icon based on given attribute type and format and target type in case of ref attribute */
export function getAttributeIcon(type?: C8AttributeType, format?: string, relationshipTargetType?: C8NodeType): FunctionComponent {
	if (type) {
		const baseType = getPrimitiveValueType(type);

		switch (baseType) {
			case BOOLEAN: {
				return BooleanIcon;
			}
			case DOUBLE:
			case INTEGER:
			case INT64: {
				return isPercentFormat(format) ? PercentIcon : (isCurrencyFormat(format) ? CurrencyIcon : NumberIcon);
			}
			case ENUM: {
				return DropDownIcon;
			}
			case REF: {
				return REF_TARGET_ICONS[relationshipTargetType] ?? ReferralIcon;
			}
			case STRING: {
				return STRING_FORMAT_ICONS[format] ?? TextIcon;
			}
			case TIME: {
				return CalendarIcon;
			}
			case URL: {
				return (format === FORMAT_IMAGE) ? ImageIcon : FileIcon;
			}
		}
	}

	return TextIcon;
}
